import { mapActions, mapState } from 'vuex'
import moment from 'moment'
import * as RoutePathConstants from '../../../../../constants/RoutePathConstants'

export default {
  data () {
    return {
      activeName: 'first',
      couponInfo: '',
      writeOffInfo: '',
      pageSizeCoupon: 3,
      pageSizeWriteOffRecord: 3
    }
  },
  computed: {
    ...mapState('myRecordModule', ['goOutMyRecordData', 'cancelRecordList']),
    couponRecordInfo () {
      return this.goOutMyRecordData
    },
    writeOffRecordInfo () {
      return this.cancelRecordList
    }
  },
  methods: {
    ...mapActions('myRecordModule', ['searchInfoByData', 'getCancelRecord', 'updateCouponRecord',
      'updateCouponFalseRecord']),
    searchInfo () {
      this.searchInfoByCondition()
    },
    writeOffRecordExpandMore () {
      this.pageSizeWriteOffRecord = this.pageSizeWriteOffRecord + 3
      this.searchWriteOffInfo()
    },
    pageSizeChange () {
      this.pageSizeCoupon = this.pageSizeCoupon + 3
      this.searchInfoByCondition()
    },
    searchInfoByCondition () {
      let data = {
        couponName: this.couponInfo,
        pageNum: 1,
        pageSize: this.pageSizeCoupon,
        pageSort: 'coupon_sales_time',
        pageOrder: 'desc'
      }
      this.searchInfoByData(data)
    },
    searchWriteOffInfo () {
      let data = {
        // writeOffInfo: this.writeOffInfo,
        pageNum: 1,
        pageSize: this.pageSizeWriteOffRecord,
        pageSort: 'verify_sales_time',
        pageOrder: 'desc'
      }
      console.log(data, 'sfsdjk')

      this.getCancelRecord(data)
    },
    handleClick (tab, event) {
      if (tab.name === 'first') {
        this.searchInfoByCondition()
      } else {
        this.searchWriteOffInfo()
      }
    },
    dateFormat (time) {
      return time ? moment(time).format('YYYY/MM/DD') : ''
    },
    arrowDown (e) {
      this.updateCouponRecord(e)
    },
    arrowUp (e) {
      this.updateCouponFalseRecord(e)
    },
    goCouponDetail (item) {
      this.$router.push({
        path: RoutePathConstants.GO_OUT_COUPON_INFO_DETAIL,
        query: {
          itemId: item.id
        }
      })
    }
  },
  mounted () {
    this.searchInfoByCondition()
  }
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/go-out-management/my-record/views/my-record-table.js